import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ACTIONS, SCREENS } from '../../../../constants/Tracking';
import { AppContext } from '../../../../contexts/app/context';
import { PageLayoutPropsContext } from '../../../../contexts/pageLayout/PropsContext';
import { generateCallObjectDirectLink } from '../../../../utils/urls';
import { DownCaratIconWrapper } from './HeaderTitle.style';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function HeaderTitle({
  title
}) {
  const {
    usageTracker,
    openUrl,
    recurringMeetings,
    isPreviousMeetingsMenuOpen,
    callObjectId,
    portalId,
    togglePreviousMeetingsMenuOpen
  } = useContext(PageLayoutPropsContext);
  const {
    isPastMeeting,
    appName
  } = useContext(AppContext);
  const {
    pathname
  } = useLocation();
  const [screen, setScreen] = useState('');
  const toggleMenuHandler = () => {
    togglePreviousMeetingsMenuOpen();
    usageTracker.trackInteraction(Object.assign({
      screen
    }, ACTIONS.planner.clickOpenRecurringMeetingsMenuButton));
  };
  const openCallObjectInHubSpot = () => {
    openUrl(generateCallObjectDirectLink(callObjectId, portalId));
    usageTracker.trackInteraction(Object.assign({
      screen
    }, ACTIONS.planner.clickOpenCallObjectInHubSpot));
  };
  useEffect(() => {
    const screenName = pathname.split('/').pop();
    setScreen(SCREENS[screenName === 'contacts' ? 'participants' : screenName]);
  }, [pathname]);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(View, {
        role: "title",
        paddingInline: "400",
        as: "div",
        children: title
      }), !isPastMeeting && recurringMeetings.length ? /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          responsive: false,
          onClick: toggleMenuHandler,
          "data-test-id": `${appName}-open-past-meetings-menu-button`,
          marginBlockStart: "200",
          children: /*#__PURE__*/_jsxs(Flex, {
            justifyContent: "center",
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.header.previousMeetings"
              })
            }), /*#__PURE__*/_jsx(DownCaratIconWrapper, {
              isPreviousMeetingsMenuOpen: isPreviousMeetingsMenuOpen,
              children: /*#__PURE__*/_jsx(DownCaratIcon, {
                color: "icon-core-subtle",
                size: "200"
              })
            })]
          })
        })
      }) : null, isPastMeeting ? /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        marginBlockStart: "500",
        paddingInline: "400",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.header.pastMeetingInfo"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "primary",
          responsive: false,
          onClick: openCallObjectInHubSpot,
          "data-test-id": `${appName}-open-call-object-in-hubspot`,
          marginBlockStart: "500",
          paddingBlock: "100",
          paddingInline: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.header.openInHubSpot"
          })
        })]
      }) : null]
    })
  });
}
export default HeaderTitle;